// chemoAdministrationInitialValues.js

export const chemoAdministrationInitialValues = {
    referralDate: null,
    cycleNumber: "",
    // dcccId: "",
    // dcccName: "",
    // chemoDrugName: "",
    // chemoDoseAdministered: "",
    // chemoAdministrationRoute: "",
    chemoInfusionRateDuration: "",
    chemoDiluentVolume: "",
    chemoTiming: "",
    chemoDeliveryMethod: "",
    chemoNotesSpecialInstructions: "",

    preChemoHydrationFluidType: "",
    preChemoHydrationFluidVolume: "",
    preChemoHydrationFluidDuration: "",

    postChemoHydrationFluidType: "",
    postChemoHydrationFluidVolume: "",
    postChemoHydrationFluidDuration: "",

    // chemoDoseModificationInstructions: "",
    significantSideEffects: "",
    medicinePrescribed: "",
    dischargeSummary: "",
    doctorName: "",
    // mobileNumber: "",

    drugDetails: [
        { drugName: "", doseAdministered: "", administrationRoute: "" }
    ],
    premedicationDetails: [
        { drugName: "", doseAdministered: "", administrationRoute: "" }
    ],
};

// Map API response to form values
export const mapChemoAdministrationResponse = (data, step5Data = null) => {
    // Helper function to map step5 drug details to form format
    const mapStep5DrugDetails = () => {
        if (!step5Data?.drug_details || step5Data.drug_details.length === 0) {
            return [{ drugName: "", doseAdministered: "", administrationRoute: "" }];
        }
        return step5Data.drug_details.map(drug => ({
            drugName: drug?.drug_name || "",
            doseAdministered: drug?.dosage || "", // Use 'dosage' field from step5Data
            administrationRoute: drug?.route_admin || "",
        }));
    };

    // Helper function to map step5 premedication details to form format
    const mapStep5PremedicationDetails = () => {
        if (!step5Data?.premedication_details || step5Data.premedication_details.length === 0) {
            return [{ drugName: "", doseAdministered: "", administrationRoute: "" }];
        }
        return step5Data.premedication_details.map(premed => ({
            drugName: premed?.drug_name || "",
            doseAdministered: premed?.drug_dose || "",
            administrationRoute: premed?.administration_route || "",
        }));
    };

    // If no saved data, return initial values with step5Data pre-filled
    if (!data) {
        return {
            ...chemoAdministrationInitialValues,
            drugDetails: mapStep5DrugDetails(),
            premedicationDetails: mapStep5PremedicationDetails(),
        };
    }

    // Map saved data
    const mappedDrugDetails = data?.drug_mo_details && data.drug_mo_details.length > 0
        ? data.drug_mo_details.map(drug => ({
            drugName: drug?.drug_name || "",
            doseAdministered: drug?.dose_administered || "",
            administrationRoute: drug?.administration_route || "",
        }))
        : null;

    const mappedPremedicationDetails = data?.premedication_mo_details && data?.premedication_mo_details.length > 0
        ? data.premedication_mo_details.map(premed => ({
            drugName: premed?.drug_name || "",
            doseAdministered: premed?.dose_administered || "",
            administrationRoute: premed?.administration_route || "",
        }))
        : null;

    return {
        referralDate: data?.referral_date || null,
        cycleNumber: data?.cycle_number || "",

        // dcccId: data?.dccc_id || "",
        // dcccName: data?.dccc_name || "",
        // chemoDrugName: data?.chemo_drug_name || "",
        // chemoDoseAdministered: data?.chemo_dose_administered || "",
        // chemoAdministrationRoute: data?.chemo_administration_route || "",

        chemoInfusionRateDuration: data?.chemo_infusion_rate_duration || "",
        chemoDiluentVolume: data?.chemo_diluent_volume || data?.chemo_diluuent_volume || "",
        chemoTiming: data?.chemo_timing || "",
        chemoDeliveryMethod: data?.chemo_delivery_method || "",
        chemoNotesSpecialInstructions: data?.chemo_notes_special_instructions || "",
        preChemoHydrationFluidType: data?.pre_chemo_hydration_fluid_type || "",
        preChemoHydrationFluidVolume: data?.pre_chemo_hydration_fluid_volume || data?.pre_chemo_hydratiom_fluid_volume || "",
        preChemoHydrationFluidDuration: data?.pre_chemo_hydration_fluid_duration || "",
        postChemoHydrationFluidType: data?.post_chemo_hydration_fluid_type || "",
        postChemoHydrationFluidVolume: data?.post_chemo_hydration_fluid_volume || data?.post_chemo_hydratiom_fluid_volume || "",
        postChemoHydrationFluidDuration: data?.post_chemo_hydration_fluid_duration || "",
        // chemoDoseModificationInstructions: data?.chemo_dose_modification_instructions || "",
        significantSideEffects: data?.significant_side_effects || "",
        medicinePrescribed: data?.medicine_prescribed || "",
        dischargeSummary: data?.discharge_summary || "",
        doctorName: data?.doctor_name || "",
        // mobileNumber: data?.mobile_number || "",

        // Use saved drug details if available, otherwise use step5Data
        drugDetails: mappedDrugDetails || mapStep5DrugDetails(),

        // Use saved premedication details if available, otherwise use step5Data
        premedicationDetails: mappedPremedicationDetails || mapStep5PremedicationDetails(),
    };
};